import React from 'react'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import { BlackMask } from '../../../../../../components/mask'
import BottomToTop from '../../../../../../components/transitions/bottom-to-top'
import { unitPrice } from '../../../../../../../utils/product'
import { FormattedMessage } from 'react-intl'
import { Iconfont } from '../../../../../../components/icon/iconfont'

export const Item = props => {
    useStyles(classes)
    const { item } = props
    return <div className={classes.ListItem}>
        <div className={classes.Image}>
            <img src={item.imageUrl} />
            {
                item.isPreOrder && <span className={classes.PreOrder}>
                    Pre order
                </span>
            }
        </div>
        <div className={classes.Info}>
            <div>
                <div className={classes.Name}>
                    {item.productName}
                </div>
                <div className={classes.SizeColor}>
                    {[item.color, item.size].filter(s => !!s)?.join(' / ')}
                </div>
            </div>

            <div className={classes.PriceQuantity}>
                <span className={classes.Price}>{unitPrice(item.realPrice)}</span>
                <span className={classes.Quantity}>x{item.quantity}</span>
            </div>
        </div>
    </div>
}


export const ItemList = props => {
    useStyles(classes)
    const { products, title, count, onClose } = props
    return <div className={classes.ItemList}>
        <div className={classes.Hd}>
            <span className={classes.Title}>
                <FormattedMessage id="shopping_bag" defaultMessage="Shopping Bag"/>
            </span>
            <Iconfont className={classes.Close} onClick={onClose}>&#xe7c9;</Iconfont>
        </div>
        <div className={classes.Dsc}>
            <span className={classes.Title}>{title}</span>
            <span className={classes.Count}>
                <FormattedMessage id="count_items" defaultMessage="{total} Items" values={{ total: count }} />
            </span>
        </div>
        <div className={classes.Bd}>
            {
                products?.map(item => <Item item={item} key={item.id}/>)
            }
        </div>
    </div>
}


export default props => {
    useStyles(classes)
    return <React.Fragment>
        <BottomToTop in={props.show} className={classes.ItemListContainer}>
            <div>
                <ItemList {...props} />
            </div>
        </BottomToTop>
        {props.show && <BlackMask onClick={props.onClose} />}
    </React.Fragment>
}

